import { useEffect } from "react";
import { useTokenService } from "../components/token/TokenService";
import { Token } from "../types/Token";




export function UsuarioEstaLogado(): boolean {
  const token = localStorage.getItem('token'); // Exemplo: verificar se há um token salvo 
  //const token = useSelector((state: RootState) => state.login.token);  
  return !!token; // Retorna true se houver um token, false caso contrário  
}
/*
export function UsuarioAdminSite(): boolean {

  const {checkTokenValidity} = useTokenService();  
  checkTokenValidity();
  
  const token = localStorage.getItem('token'); 
  const tipoSite = localStorage.getItem('tipoSite'); 
  
  
  return !!token && !! tipoSite && tipoSite==="ADMINISTRADOR"; 
}*/
export function useUsuarioAdminSite(): boolean {
  const { checkTokenValidity } = useTokenService();

  useEffect(() => {
    checkTokenValidity(); // pode ser assíncrono, mas aqui está ok
  }, [checkTokenValidity]);

  const token = localStorage.getItem("token");
  const tipoSite = localStorage.getItem("tipoSite");

  return !!token && !!tipoSite && tipoSite === "ADMINISTRADOR";
}

export function UsuarioAdminSite(): boolean {
  const { checkTokenValidity } = useTokenService();

  useEffect(() => {
    checkTokenValidity(); // pode ser assíncrono, mas aqui está ok
  }, [checkTokenValidity]);

  const token = localStorage.getItem("token");
  const tipoSite = localStorage.getItem("tipoSite");

  return !!token && !!tipoSite && tipoSite === "ADMINISTRADOR";
}

export function UsuarioLogadoGet(): Token {
  
  const token = localStorage.getItem('token');
  const usuario = localStorage.getItem('usuario');
  const ip = localStorage.getItem('ip');
  const tipo = localStorage.getItem('tipo');
  const id = localStorage.getItem('id');
  const setorId = localStorage.getItem('setorId');
  const setorNome = localStorage.getItem('setorNome');  
  const tipoSite = localStorage.getItem('tipoSite');  
  
  return { token, usuario, ip, tipo, id, setorId, setorNome,tipoSite };
}

export function UsuarioLogout() {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  localStorage.removeItem('ip');
  localStorage.removeItem('tipo');
  localStorage.removeItem('id');
  localStorage.removeItem('setorId');
  localStorage.removeItem('setorNome');
  localStorage.removeItem('tipoSite');
}

export function UsuarioSaveToken(data: Token) {
  if (data.token) {
    localStorage.setItem('token', data.token);

    if (data.usuario) {
      localStorage.setItem('usuario', data.usuario.toUpperCase());
    }

    if (data.ip) {
      localStorage.setItem('ip', data.ip);
    }
    if (data.tipo) {
      localStorage.setItem('tipo', data.tipo.toUpperCase());
    }
    if (data.id) {
      localStorage.setItem('id', data.id);
    }
    if (data.setorId) {
      localStorage.setItem('setorId', data.setorId);
    }
    if (data.setorNome) {
      localStorage.setItem('setorNome', data.setorNome.toUpperCase());
    }
    if (data.tipoSite) {
      localStorage.setItem('tipoSite', data.tipoSite.toUpperCase());
    }
  }
}





